import React from 'react';
import PropTypes from 'prop-types';
import { Message, Button } from 'semantic-ui-react';

// Final success / error state for the force action.
function ForceResultMessage({ result, disabled, onReset }) {
  if (!result) return null;

  const { success, message, status } = result;

  return (
    <Message
      positive={success}
      negative={!success}
      icon
      data-testid='force-guarantee-result'
    >
      <Message.Content>
        <Message.Header>
          {success ? 'Guarantee Created' : 'Guarantee Not Created'}
        </Message.Header>
        <p>{message}</p>
        {success && status && (
          <p>
            <b>Status:</b> {status}
          </p>
        )}
        <Button
          size='small'
          onClick={onReset}
          disabled={disabled}
          data-testid='force-guarantee-start-over-button'
          style={{ marginTop: '0.5em' }}
        >
          Start New Request
        </Button>
      </Message.Content>
    </Message>
  );
}

ForceResultMessage.propTypes = {
  result: PropTypes.shape({
    success: PropTypes.bool,
    message: PropTypes.string,
    status: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
};

ForceResultMessage.defaultProps = {
  result: null,
  disabled: false,
};

export default ForceResultMessage;
